import { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";

export default function History() {
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/attempts").then((r) => setAttempts(r.data)).finally(() => setLoading(false));
  }, []);

  const badge = (a) => a >= 90 ? "text-green-700" : a >= 70 ? "text-yellow-700" : "text-red-700";

  return (
    <div className="min-h-screen bg-background text-foreground">
      <Navbar />
      <main className="max-w-7xl mx-auto px-6 py-12">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-brand-gold mb-4">History</div>
          <h1 className="text-4xl lg:text-5xl font-black tracking-tight" data-testid="history-title">Your attempts</h1>
        </div>

        {loading ? (
          <div className="font-mono text-muted-foreground">Loading…</div>
        ) : attempts.length === 0 ? (
          <div className="border-2 border-dashed border-border p-10 text-center font-mono text-muted-foreground" data-testid="history-empty">
            No attempts yet. Start practising a module.
          </div>
        ) : (
          <div className="border border-border overflow-x-auto" data-testid="history-table">
            <table className="w-full text-sm font-mono min-w-[720px]">
              <thead className="bg-secondary/60">
                <tr>
                  <th className="text-left px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">Date</th>
                  <th className="text-left px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">Module</th>
                  <th className="text-right px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">Accuracy</th>
                  <th className="text-right px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">WPM</th>
                  <th className="text-right px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">Correct</th>
                  <th className="text-right px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">Errors</th>
                  <th className="text-right px-4 py-3 text-xs uppercase tracking-[0.2em] font-bold">Time</th>
                </tr>
              </thead>
              <tbody>
                {attempts.map((a) => (
                  <tr key={a.id} className="border-t border-border" data-testid={`history-row-${a.id}`}>
                    <td className="px-4 py-3">{new Date(a.created_at).toLocaleString()}</td>
                    <td className="px-4 py-3 capitalize">{a.module}</td>
                    <td className={`px-4 py-3 text-right font-bold ${badge(a.accuracy_percent)}`}>{a.accuracy_percent}%</td>
                    <td className="px-4 py-3 text-right">{a.wpm}</td>
                    <td className="px-4 py-3 text-right text-green-700">{a.correct}</td>
                    <td className="px-4 py-3 text-right text-red-700">{a.incorrect + a.missing + a.extra}</td>
                    <td className="px-4 py-3 text-right">{Math.round(a.time_seconds)}s</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </main>
    </div>
  );
}
